import script from "./LogCompactTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LogCompactTable.vue?vue&type=script&setup=true&lang=js"

import "./LogCompactTable.vue?vue&type=style&index=0&id=514b5d62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-514b5d62"]])

export default __exports__